export enum userTypesIds {
  Administrador = 1,
  Colorin = 2,
  Industria = 3,
  HayColor = 4,
  Integraciones = 5,
  Teclum = 6,
}

export const userTypes = {
  [1]: 'Administrador',
  [2]: 'Colorin',
  [3]: 'Industria',
  [4]: 'Hay Color',
  [5]: 'Integraciones',
  [6]: 'Teclum',
};

export const creatableUserTypeByUserType = {
  [userTypesIds.Administrador]: [
    userTypesIds.Administrador,
    userTypesIds.Colorin,
    userTypesIds.HayColor,
    userTypesIds.Industria,
    userTypesIds.Teclum,
  ],
  [userTypesIds.Colorin]: [userTypesIds.Colorin],
  [userTypesIds.HayColor]: [userTypesIds.HayColor],
  [userTypesIds.Industria]: [userTypesIds.Industria],
  [userTypesIds.Teclum]: [userTypesIds.Teclum],
};
